import { UserRole } from 'src/services/user/types';

export const restrictedPaths: Record<string, UserRole[]> = {
  '/manage-firms': ['SUPER_ADMIN'],
  '/manage-collections': ['SUPER_ADMIN'],
  '/manage-firms/*': ['FIRM_ADMIN', 'SUPER_ADMIN'],
  '/manage-firms/:id': ['FIRM_ADMIN'],
  '/manage-videos': ['SUPER_ADMIN'],
  '/my-favorites': ['ATTORNEY', 'FIRM_ADMIN'],
  '/settings': ['SUPER_ADMIN'],
  '/statistics': ['SUPER_ADMIN', 'FIRM_ADMIN'],
  '/shared-with-me': ['ATTORNEY', 'FIRM_ADMIN'],
  '/video/:videoId': [
    'ATTORNEY',
    'FIRM_ADMIN',
    'SUPER_ADMIN',
  ],
  'work-better.com': ['FIRM_ADMIN', 'SUPER_ADMIN'],
};
